import { Card, List } from "reactstrap";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { useContext, useEffect, useState } from "react";
import { ToastContextDispatch } from "Context/CommonContext";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import { BASE_URL, GET_FAQ_DATA } from "utilFunctions/Constants/urlConstants";
import "./index.css";
import LeftArrow from "Assets/Icons/LeftArrow";
import { useNavigate } from "react-router-dom";
import Typography from "Components/CommonComponents/Typography";

const FAQ = () => {
  const navigate = useNavigate();
  const ToastDispatch = useContext(ToastContextDispatch);
  const [FAQData, setFAQData] = useState<any>([]);
  const [limit] = useState<number>(10);
  const { makeRequest: GetFAQDATA } = useGetApi(
    (data) => {
      setFAQData(data?.data);
    },
    (error) => {
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["error"]
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message:
            error["response"]["data"]["error"] ||
            (error["response"]["data"] && error["response"]["data"]["message"]),
        });
      }
    }
  );

  useEffect(() => {
    GetFAQDATA(BASE_URL + GET_FAQ_DATA + "&offset=0" + "&limit=" + limit);
  }, []);
  return (
    <Card className="faqCard mt-4 ml-5 mr-5">
      <div className="tableFixHead">
        {FAQData && Array.isArray(FAQData) && FAQData.length === 0 ? (
          <div className="mt-4 mb-8">
            <NoResultFoundSearch
              primaryMessage="No data present"
              secondaryMessage={
                "There is either no data available or the system is currently in the process of syncing data."
              }
            >
              <NoDataFoundIcon />
            </NoResultFoundSearch>
          </div>
        ) : (
          <>
            <div className="d-flex align-items-center">
              <LeftArrow
                className={"cursorHoverCSS mr-3 mt-n2"}
                onClick={() => {
                  navigate("/admin/dashboard", {
                    replace: true,
                    state: {
                      selectedStudent: null,
                    },
                  });
                }}
              ></LeftArrow>
              <Typography variant="headingH3" color="black">
                Frequently asked questions
              </Typography>
            </div>
            {FAQData &&
              Array.isArray(FAQData) &&
              FAQData.length > 0 &&
              FAQData.map((faqItem: any) => (
                <List key={faqItem.id} className="listA">
                  <li className="w-100">
                    <div className="mainDiv d-flex justify-content-between flex-row w-100">
                      <div className="headingTitle">{faqItem.text}</div>
                      <div>
                        <a
                          href={faqItem.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="viewLink"
                        >
                          View
                        </a>
                      </div>
                    </div>
                  </li>
                </List>
              ))}
          </>
        )}
      </div>
    </Card>
  );
};
export default FAQ;
